import { atomWithReset } from "jotai/utils";

import type { AutomationListItem } from "../types";

export const automationSetupNotifyModalAtom = atomWithReset<{
  visible: boolean;
  automation: AutomationListItem | null;
}>({ visible: false, automation: null });
